<emm-management-layout>
  <emm-progress-bar [isLoading$]="anyLoading$"></emm-progress-bar>
  <emm-search-filter
    [addDialog]="true"
    [attr.data-testid]="'location_set_types_search_bar'"
    [displaySearchWithOptions]="false"
    [fields]="fields$ | async"
    [isAdminOrAuthor]="(this.isAdmin || this.isAuthor) && !isMMSAuthor"
    [isSuperAdmin]="this.isSuperAdmin"
    (add)="openCreateLocationSetTypeDialog()"
    (filter)="onFilter($event)"
    layout-center-header
  ></emm-search-filter>
  <emm-generic-items-list
    [contextMenuActions]="locationSetTypesContextMenuActions"
    [disableContextActions]="anyLoading$ | async"
    [isReadOnly]="isReadOnly$ | async"
    [items]="locationSetTypes$ | async"
    layout-center-content
    (onSelectItem)="onSelectLocationSetType($event)"
  ></emm-generic-items-list>
  @if (itemDetail$ | async; as item) {
    <emm-management-attributes-header
      layout-right-header
      [name]="item.name"
      [tag]="item.tag"
    ></emm-management-attributes-header>
  }
  <emm-location-set-types-form
    #form
    layout-right-content
    [isSuperAdmin]="isSuperAdmin"
  ></emm-location-set-types-form>
  @if ((itemDetail$ | async) && !isMMSAuthor) {
    <emm-management-attributes-footer
      [disableCancel]="!locationSetTypesForm || !locationSetTypesForm.isFormReady()"
      [disableUpdate]="!locationSetTypesForm || !locationSetTypesForm.hasChanges()"
      layout-right-footer
      (cancel)="locationSetTypesForm.cancel()"
      (submit)="submitForm()"
      class="fixed-row-bottom"
    ></emm-management-attributes-footer>
  }
</emm-management-layout>
